import React from "react";
import { Barras, COLORES, Columnas, Kpis, Linea, Pagina, Tabla, Tarjeta, fmtM, fmtN, fmtP, useDatos, usePeriodo } from "./comun";

function ReporteRentabilidad() {
  const periodo = usePeriodo();
  const { datos: d, error } = useDatos(`/rentabilidad/${periodo.inicio}/${periodo.fin}`);
  const k = d?.kpis;
  const margen = (x) => `${fmtP(x.margen)} margen`;
  return (
    <Pagina titulo="Rentabilidad" subtitulo="Cuanto deja cada vino despues de su costo" periodo={periodo} error={error} cargando={!d}>
      {d && <>
        <Kpis items={[
          { t: "Venta neta", v: fmtM(k.venta) }, { t: "Costo de venta", v: fmtM(k.costo) },
          { t: "Utilidad bruta", v: fmtM(k.utilidad), d: `${fmtP(k.margen)} margen` },
          { t: "Gastos", v: fmtM(k.gastos) },
          { t: "Utilidad operativa", v: fmtM(k.operativa), d: `${fmtP(k.margenOperativo)} margen`, tono: k.operativa < 0 ? "baja" : "sube" },
        ]} />
        <div className="rp-grid">
          <Tarjeta titulo="Utilidad bruta por mes"><Columnas datos={d.meses} series={[{ key: "utilidad", label: "Utilidad", color: COLORES[0] }]} /></Tarjeta>
          <Tarjeta titulo="Margen por mes"><Linea datos={d.meses} campo="margen" etiqueta="Margen" /></Tarjeta>
          <Tarjeta titulo="Vinos que mas dejan"><Barras datos={d.masRentables} valor="utilidad" extra={margen} /></Tarjeta>
          <Tarjeta titulo="Clientes que mas dejan"><Barras datos={d.porCliente} valor="utilidad" extra={margen} /></Tarjeta>
          <Tarjeta titulo="Por tipo de vino"><Barras datos={d.porTipo} valor="utilidad" extra={margen} /></Tarjeta>
          <Tarjeta titulo="Por region"><Barras datos={d.porRegion} valor="utilidad" extra={margen} /></Tarjeta>
          <Tarjeta titulo="Vinos con menor margen" nota="Revisar precio o costo" ancho>
            <Tabla filas={d.menorMargen} columnas={[{ t: "Vino", k: "nombre" }, { t: "Botellas", k: "botellas", f: fmtN, n: 1 }, { t: "Venta", k: "venta", f: fmtM, n: 1 }, { t: "Utilidad", k: "utilidad", f: fmtM, n: 1 }, { t: "Margen", k: "margen", f: fmtP, n: 1 }]} />
          </Tarjeta>
        </div>
      </>}
    </Pagina>
  );
}
export default ReporteRentabilidad;
